(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaps-Home-header"] && !Shopify.designMode) return;
  try {
    
  // ... existing code ...

  // Add mobile submenu toggle functionality
  document.querySelectorAll('.mobile-menu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const menuItem = toggle.closest('.mobile-menu-item');
      const submenu = menuItem.querySelector('.submenu');
      const arrow = menuItem.querySelector('.menu-arrow');

      if (submenu.style.display === 'none') {
        submenu.style.display = 'block';
        arrow.style.transform = 'rotate(90deg)';
      } else {
        submenu.style.display = 'none';
        arrow.style.transform = 'rotate(0)';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaps-home-sec5"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.location-tab');
    const locationWrappers = document.querySelectorAll('.location-card-wrapper');
  
    // Hide all wrappers initially
    locationWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
    });
  
    // Show "All Locations" by default
    const defaultWrapper = document.querySelector('.location-card-wrapper[data-filter-id="filterAll"]');
    if (defaultWrapper) {
      defaultWrapper.style.display = 'flex';
    }
  
    // Add active class to "All Locations" button by default
    const defaultButton = document.querySelector('#filterAll');
    if (defaultButton) {
      defaultButton.classList.add('active');
    }
  
    // Handle filter button clicks
    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Remove active from all buttons
        filterButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
  
        const filterId = this.id;
  
        // Hide all wrappers
        locationWrappers.forEach(wrapper => {
          wrapper.style.display = 'none';
        });
  
        // Show the selected wrapper
        const selectedWrapper = document.querySelector(`.location-card-wrapper[data-filter-id="${filterId}"]`);
        if (selectedWrapper) {
          selectedWrapper.style.display = 'flex';
        }
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaps-location-sec2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
const wrapper = document.querySelector(".location-map-wrapper");
const timeZone = wrapper?.dataset.timezone;

function getOpenStatus(card) {
  try {
    const raw = card.dataset.openingHours;
    if (!raw || !timeZone) return { ok: false };

    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    const getPart = type => parts.find(p => p.type === type)?.value;
    const today = getPart("weekday").toLowerCase();
    const nowMins =
      parseInt(getPart("hour"), 10) * 60 +
      parseInt(getPart("minute"), 10);

    const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    const todayIndex = days.indexOf(today);

    const normalise = str => str
      .replace(/[–—]/g, "-")
      .replace(/\s+/g, " ")
      .trim();

    const lines = normalise(raw).split(/\n|<br\s*\/?>/i);

    function hoursForDay(dayIndex) {
  const day = days[dayIndex];

  const dayAliases = {
    mon: ["mon", "monday"],
    tue: ["tue", "tues", "tuesday"],
    wed: ["wed", "wednesday"],
    thu: ["thu", "thur", "thurs", "thursday"],
    fri: ["fri", "friday"],
    sat: ["sat", "saturday"],
    sun: ["sun", "sunday"]
  };

  const dayOrder = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const getDayKey = str => {
    const s = str.toLowerCase().trim();

    for (const [key, aliases] of Object.entries(dayAliases)) {
      if (aliases.some(alias => s === alias)) return key;
    }

    return null;
  };

  for (const line of lines) {
    const lower = line.toLowerCase();

    const rangeMatch = lower.match(
      /^(mon(?:day)?|tue(?:s|sday)?|wed(?:nesday)?|thu(?:r|rs|rsday)?|fri(?:day)?|sat(?:urday)?|sun(?:day)?)\s+to\s+(mon(?:day)?|tue(?:s|sday)?|wed(?:nesday)?|thu(?:r|rs|rsday)?|fri(?:day)?|sat(?:urday)?|sun(?:day)?)/i
    );

    if (rangeMatch) {
      const startDay = getDayKey(rangeMatch[1]);
      const endDay = getDayKey(rangeMatch[2]);

      if (startDay && endDay) {
        const start = dayOrder.indexOf(startDay);
        const end = dayOrder.indexOf(endDay);
        const current = dayOrder.indexOf(day);

        const inRange =
          start <= end
            ? current >= start && current <= end
            : current >= start || current <= end;

        if (inRange) return line;
      }
    }

    if (
      dayAliases[day].some(alias =>
        lower.startsWith(alias + ":") ||
        lower.startsWith(alias + " ")
      )
    ) {
      return line;
    }
  }

  return null;
}

    function parseHours(line) {
      if (!line || /closed/i.test(line)) return null;

      const match = line.match(
        /(\d{1,2})(?::(\d{2}))?\s*(am|pm)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)/i
      );

      if (!match) return null;

      const toMins = (hour, minute, period) => {
        let h = parseInt(hour, 10);
        const m = parseInt(minute || "0", 10);

        if (period.toLowerCase() === "am" && h === 12) h = 0;
        if (period.toLowerCase() === "pm" && h !== 12) h += 12;

        return h * 60 + m;
      };

      return {
        open: toMins(match[1], match[2], match[3]),
        close: toMins(match[4], match[5], match[6])
      };
    }

    const formatTime = mins => {
      let h = Math.floor(mins / 60);
      const m = mins % 60;
      const period = h >= 12 ? "PM" : "AM";

      h = h % 12 || 12;

      return m
        ? `${h}:${String(m).padStart(2, "0")} ${period}`
        : `${h} ${period}`;
    };

    const todayHours = parseHours(hoursForDay(todayIndex));

    if (todayHours) {
      const { open, close } = todayHours;

      const isOpen =
        close > open
          ? nowMins >= open && nowMins < close
          : nowMins >= open || nowMins < close;

      if (isOpen) {
        return {
          ok: true,
          open: true,
          label: `OPEN NOW · CLOSES ${formatTime(close)}`
        };
      }

      if (nowMins < open) {
        return {
          ok: true,
          open: false,
          label: `CLOSED · OPENS ${formatTime(open)}`
        };
      }
    }

    for (let offset = 1; offset <= 7; offset++) {
      const nextIndex = (todayIndex + offset) % 7;
      const nextHours = parseHours(hoursForDay(nextIndex));

      if (nextHours) {
        return {
          ok: true,
          open: false,
          label:
            offset === 1
              ? `CLOSED · OPENS ${formatTime(nextHours.open)} TOMORROW`
              : `CLOSED · OPENS ${formatTime(nextHours.open)} ${days[nextIndex].toUpperCase()}`
        };
      }
    }

    return { ok: false };

  } catch (e) {
    return { ok: false };
  }
}

  const mapEl = document.createElement("div");
  mapEl.id = "locationMap";
  mapEl.style.height = "560px";
  mapEl.className = "rounded-4 ms-lg-3 w-100";

  const iframe = document.getElementById("map-iframe");
  iframe?.replaceWith(mapEl);

  const cards = document.querySelectorAll(".location-card");
  if (!mapEl || cards.length === 0) return;

  cards.forEach(card => {
  const statusEl = card.querySelector(".location-status");
  if (!statusEl) return;

  const status = getOpenStatus(card);

  if (status.ok) {
    statusEl.textContent = status.label;
    statusEl.classList.toggle("is-open", status.open);
    statusEl.classList.toggle("is-closed", !status.open);
  }
});

  const map = L.map(mapEl).setView([25.276987, 55.296249], 10);
  // L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
  //   attribution:
  //     '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
  // }).addTo(map);

  L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
  attribution: '&copy; <a href="https://www.esri.com/">Esri</a> contributors',
  maxZoom: 16
}).addTo(map);

L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
  maxZoom: 16
}).addTo(map);

  // const geocoder = L.Control.Geocoder.nominatim();
  const geocoder = L.Control.Geocoder.nominatim({
  geocodingQueryParams: {
    'accept-language': 'en'
  }
});
  const bounds = L.latLngBounds();
  const locations = [];

  cards.forEach(card => {
    const name = card.dataset.locationName;
    const address = card.dataset.locationAddress;
    const bookUrl = card.querySelector(".book-btn")?.href || "#";
    

    if (!address) return;

    console.log("Geocoding:", address);

    geocoder.geocode(address, results => {
      if (!results || !results.length) {
        console.warn("No results for:", address);
        return;
      }

      const customIcon = L.icon({
  iconUrl: "data:image/svg+xml;base64," + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
      <path d="M12.5 0C5.6 0 0 5.6 0 12.5C0 22.1 12.5 41 12.5 41C12.5 41 25 22.1 25 12.5C25 5.6 19.4 0 12.5 0Z" fill="#b8946a"/>
      <circle cx="12.5" cy="12.5" r="5" fill="white"/>
    </svg>
  `),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -41]
});

const hoverIcon = L.icon({
  iconUrl: "data:image/svg+xml;base64," + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
      <path d="M12.5 0C5.6 0 0 5.6 0 12.5C0 22.1 12.5 41 12.5 41C12.5 41 25 22.1 25 12.5C25 5.6 19.4 0 12.5 0Z" fill="#221f20"/>
      <circle cx="12.5" cy="12.5" r="5" fill="white"/>
    </svg>
  `),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [0, -41]
});

      const { center } = results[0];
      const marker = L.marker(center, { icon: customIcon })
        .addTo(map)
        .bindPopup(`
          <h4 class="font-20 fw-medium mb-1">${name}</h4>
          <p class="mb-3">${address}</p>
          <a class="btn btn-primary bg-dark text-uppercase text-white rounded-3 text-md fw-bold border-dark px-3 py-3 w-100" href="${bookUrl}" target="_blank">Book</a>
        `);

        marker.bindTooltip(name, {
  direction: "top",
  offset: [0, -41],
  opacity: 1,
  className: "chaps-location-tooltip"
});

marker.on("mouseover", function () {
  this.setIcon(hoverIcon);
  this.openTooltip();
});

marker.on("mouseout", function () {
  this.setIcon(customIcon);
  this.closeTooltip();
});

marker.on("click", function () {
  const scrollContainer = card.closest(".overflow-auto");

  if (scrollContainer) {
    const containerRect = scrollContainer.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();

    const targetTop =
      scrollContainer.scrollTop +
      (cardRect.top - containerRect.top) -
      (scrollContainer.clientHeight / 2) +
      (cardRect.height / 2);

    scrollContainer.scrollTo({
      top: targetTop,
      behavior: "smooth"
    });
  }

  // Restart the temporary gold highlight
  card.classList.remove("map-location-highlight");

  requestAnimationFrame(() => {
    card.classList.add("map-location-highlight");
  });

  setTimeout(() => {
    card.classList.remove("map-location-highlight");
  }, 1800);
});

      bounds.extend(center);
      locations.push({ name, address, marker, card });

      card.addEventListener("click", () => {
        map.setView(center, 15);
        marker.openPopup();
      });

      map.fitBounds(bounds, { padding: [40, 40] });
    });
  });

  // Search functionality
  const searchInput = document.getElementById("locationSearch");
  searchInput?.addEventListener("input", e => {
    const term = e.target.value.toLowerCase();
    cards.forEach(card => {
      const name = card.dataset.locationName;
      const address = card.dataset.locationAddress;
      const visible = name.includes(term) || address.includes(term);
      card.style.display = visible ? "block" : "none";
    });
  });

  // Current location functionality
  const locationCheck = document.getElementById("currentLocationCheck");
  locationCheck?.addEventListener("change", e => {
    if (!e.target.checked || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(pos => {
      const cl = [pos.coords.latitude, pos.coords.longitude];
      map.setView(cl, 13);
      L.circle(cl, {
        radius: 100,
        color: "blue",
        fillOpacity: 0.3
      }).addTo(map);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
